import React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { blue } from '../../theme';

const CameraCard = (props) => {
  const styles = StyleSheet.create({
    cameraCard: {
      display: 'flex',
      alignItems: 'center',
      height: '40px',
      background: blue[700],
      color: blue[400],
      borderRadius: '5px',
      cursor: 'pointer'
    }
  });
  return (
    <div
      className={css(styles.cameraCard)}
      onClick={() => { props.onClick(); }}
    >
      {props.showAlert &&
        <svg
          width="16"
          height="16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className='ml-1'
        >
          <path fillRule="evenodd" clipRule="evenodd" d="M15.997 0H0v16h16V0h-.003Zm0 0v16l-5.622-8 5.622-8Z" fill="#FF6060"/>
        </svg>
      }
      <i
        className='fa fa-camera'
        style={{
          marginLeft: !props.showAlert ? '28px' : '0.5rem'
        }}
      />
      <div className='ml-2 noselect'>
        {props.text}
      </div>
    </div>
  );
};

CameraCard.defaultProps = {
  showAlert: false
};

export default CameraCard;
